import { registerRootComponent } from 'expo'
import { StyleSheet, Text, View } from 'react-native'
import App from './src/Route/App'
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'
registerRootComponent(App)
